import {
  Alert, Box, Typography,
} from '@mui/material';
import styled from 'styled-components';

interface LoadingContainerProps {
  decorate: boolean,
}

const LoadingContainer = styled.div<LoadingContainerProps>`
  height: ${({ decorate, theme }) => (decorate ? `calc(100vh - ${theme.shape.appbarHeight * 2}px)` : '100vh')};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface MainProps {
  open: boolean;
  $isMd: boolean;
}

const Main = styled(Box)<MainProps>`
  width: ${({ theme, $isMd }) => ($isMd ? `calc(100% - ${theme.shape.drawerWidth})px` : '100%')};
  flex-grow: 1;
  margin-left: ${({ open, theme, $isMd }) => (open && $isMd ? `${theme.shape.drawerWidth}px` : 0)};
  transition: ${({ open, theme }) => (open ?
    theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }) : theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }))};
  padding-top: ${({ theme, $isMd }) => theme.spacing($isMd ? 4 : 6)};
  padding-bottom: ${({ theme, $isMd }) => theme.spacing($isMd ? 4 : 2)};
  padding-left: ${({ theme, $isMd }) => theme.spacing($isMd ? 4 : 2)};
  padding-right: ${({ theme, $isMd }) => theme.spacing($isMd ? 4 : 2)};
`;

const ContentContainer = styled.div`
  display: flex;
`;

const Nav = styled(Box)``;

const SnackbarAlert = styled(Alert)`
  && {
    width: 100%;
  }
`;

const MessageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 80vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const IconContainer = styled.div`
  color: ${({ theme }) => theme.palette.darkPrimary.main};
  @keyframes bounce {
    0%, 20%, 50%, 70%, 90%, 100% { transform: translateY(0); }
    40% { transform: translateY(-12px); }
    60% { transform: translateY(-8px); }
    80% { transform: translateY(-5px); }
  }
  animation: bounce 1.5s ease;
  display: flex;
`;

const IconBorder = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.palette.darkPrimary.light}80;
  border-style: dotted;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MessageTitle = styled(Typography)`
  && {
    margin-top: ${({ theme }) => theme.spacing(2)};
    margin-bottom: ${({ theme }) => theme.spacing(1)};
    color: ${({ theme }) => theme.palette.darkPrimary.main};
  }
`;

const MessageContent = styled(Typography)`
  && {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

export { LoadingContainer,
  IconContainer,
  IconBorder,
  MessageContent,
  MessageTitle,
  MessageContainer,
  Main,
  ContentContainer,
  Nav,
  SnackbarAlert };
